document.addEventListener('DOMContentLoaded', () => {
    const popup = document.getElementById('NotesPopup');

    if (!popup) return;

    const input = popup.querySelector('.notes-popup__search');
    const grid = popup.querySelector('.notes-popup__grid');
    const cards = popup.querySelectorAll('.notes-card');
    const empty = popup.querySelector('.notes-empty');

    function resetSearch() {
        if (!input) return;

        input.value = '';

        cards.forEach(card => {
            card.style.display = '';
        });

        if (empty) {
            empty.hidden = true;
        }

        if (grid) {
            grid.scrollTop = 0;
        }
    }

    function openPopup() {
        popup.classList.add('is-visible');

        resetSearch();

        if (input) {
            setTimeout(() => {
                input.focus();
            }, 150);
        }
    }

    function closePopup() {
        popup.classList.remove('is-visible');
    }

    // Open popup
    document.querySelectorAll('[data-open-notes-popup]').forEach(trigger => {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            openPopup();
        });
    });

    // Close buttons
    popup.querySelectorAll('[data-close-notes-popup]').forEach(btn => {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            closePopup();
        });
    });

    // Close on overlay click
    const overlay = popup.querySelector('.notes-popup__overlay');

    if (overlay) {
        overlay.addEventListener('click', closePopup);
    }

    // ESC key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
            closePopup();
        }
    });

    // Live search
    if (input) {
        input.addEventListener('input', function () {
            const value = this.value.trim().toLowerCase();

            let visible = 0;

            cards.forEach(card => {
                const text = (card.dataset.note || '').toLowerCase();
                const show = text.includes(value);

                card.style.display = show ? '' : 'none';

                if (show) {
                    visible++;
                }
            });

            if (empty) {
                empty.hidden = visible !== 0;
            }
        });
    }
});